import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import WallAppBar from './Components/AppBar/WallAppBar'
import Typography from '@mui/material/Typography';
import Config from './Config.json'
import PublicIcon from '@mui/icons-material/Public';
import LanguageIcon from '@mui/icons-material/Language';

export default function NotFound() {
    return (
        <Box sx={{ flexGrow:1 }} className="App-header" >
            <WallAppBar />
            <LanguageIcon sx={{fontSize:100, animation: "spin 5s linear infinite",
                "@keyframes spin": {
                "0%": {
                    transform: "rotate(360deg)",
                },
                "100%": {
                    transform: "rotate(0deg)",
                },
                }}} 
            />
            <br/>
            <Typography>
                Lost? Click <b><a href={Config.urlStub+"app"} 
                style={{textDecoration: 'none', color:"lightGreen"}}>here</a></b> to go home.
            </Typography>
        </Box>
    )
}